<section class="synagogueBalance w-full max-w-6xl mx-auto px-3 md:px-6 py-6 space-y-6" dir="rtl">

  <header class="flex flex-col md:flex-row md:items-end md:justify-between gap-3">
    <div class="flex flex-col gap-1">
      <p class="text-base text-ink-500">בית כנסת</p>
      <h1 class="text-3xl font-bold text-primary-700">{{ header }}</h1>
    </div>

    <a routerLink="/synagogue/add" class="btn-2026--primary w-full md:w-auto md:min-w-[200px]">
      <span class="material-symbols-outlined" aria-hidden="true">add_circle</span>
      פעולה חדשה
    </a>
  </header>

  <ng-container *ngIf="balance.length > 0; else empty">

    <!-- ── Mobile cards (< md) ─────────────────────────────────── -->
    <div class="md:hidden space-y-2">
      <div *ngFor="let row of balance"
           class="card-2026 !p-3 cursor-pointer hover:bg-primary-50/40 transition-colors"
           [routerLink]="row.transactionId">
        <div class="flex justify-between items-start gap-2">
          <div>
            <span class="inline-flex items-center gap-1.5 font-medium text-sm"
                  [class.text-success]="row.type === 1"
                  [class.text-danger]="row.type === 2">
              <i class="material-symbols-outlined !text-base" aria-hidden="true">
                {{ row.type === 1 ? 'south_east' : 'north_west' }}
              </i>
              {{ row.type === 1 ? 'הכנסה' : 'הוצאה' }}
            </span>
            <div class="text-xs text-ink-500 mt-1">
              {{ row.createdAt | date : 'd בMMM y' : '' : 'he-IL' }}
            </div>
          </div>
          <div class="text-end">
            <div class="money font-bold"
                 [class.money--credit]="row.type === 1"
                 [class.money--debt]="row.type === 2">
              {{ row.transactionAmount | currency : 'ILS' : 'symbol' : '1.0-2' }}
            </div>
          </div>
        </div>
        <div class="mt-2 pt-2 border-t border-ink-100 flex justify-between items-center">
          <span class="text-xs text-ink-500 font-medium">יתרה לאחר הפעולה</span>
          <span class="money font-bold text-base"
                [class.money--credit]="row.balance > 0"
                [class.money--debt]="row.balance < 0"
                [class.money--zero]="row.balance === 0">
            {{ row.balance | currency : 'ILS' : 'symbol' : '1.0-2' }}
          </span>
        </div>
      </div>
    </div>

    <!-- ── Tablet+ table (≥ md) ────────────────────────────────── -->
    <div class="hidden md:block overflow-x-auto">
      <table class="table-2026 w-full">
        <thead>
          <tr>
            <th>תאריך</th>
            <th>פעולה</th>
            <th class="text-end">סכום</th>
            <th class="text-end">יתרה</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of balance"
              class="cursor-pointer"
              [routerLink]="row.transactionId">
            <td>{{ row.createdAt | date : 'd בMMM y' : '' : 'he-IL' }}</td>
            <td>
              <span class="inline-flex items-center gap-1.5 font-medium"
                    [class.text-success]="row.type === 1"
                    [class.text-danger]="row.type === 2">
                <i class="material-symbols-outlined text-base" aria-hidden="true">
                  {{ row.type === 1 ? 'south_east' : 'north_west' }}
                </i>
                {{ row.type === 1 ? 'הכנסה' : 'הוצאה' }}
              </span>
            </td>
            <td class="text-end money font-semibold"
                [class.money--credit]="row.type === 1"
                [class.money--debt]="row.type === 2">
              {{ row.transactionAmount | currency : 'ILS' : 'symbol' : '1.0-2' }}
            </td>
            <td class="text-end money font-semibold"
                [class.money--credit]="row.balance > 0"
                [class.money--debt]="row.balance < 0"
                [class.money--zero]="row.balance === 0">
              {{ row.balance | currency : 'ILS' : 'symbol' : '1.0-2' }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>

  <ng-template #empty>
    <div class="card-2026 text-center py-12">
      <i class="material-symbols-outlined text-5xl text-ink-300 mb-2" aria-hidden="true">account_balance</i>
      <h2 class="text-xl font-semibold text-ink-700">אין עדיין תנועות</h2>
      <p class="text-base text-ink-500 mt-1">הוסף הכנסה או הוצאה ראשונה</p>
    </div>
  </ng-template>
</section>
